import { TypeCodeHelper } from "../app/infrastructure/typeCodeHelper";

var envir = {
  production: false,
  company: "Thành Bưởi",
  title: "Thành Bưởi",
  name: "Thành Bưởi",
  urlFirebase: "https://fcm.googleapis.com/fcm/send",

  gMapKey: "AIzaSyCx7wym-bB_udD1pRi0PWS97UVScSXtqEc",

  namePrint: "THANHBUOI",
  formatDate: "YYYY/MM/DD",
  formatDateTable: "yyyy/MM/dd",
  formatTime: "HH:mm",
  formatDateTime: "YYYY/MM/DD HH:mm",
  formatDateTimeTable: "yyyy/MM/dd HH:mm",
  unit: "(kg)",

  centerHubLongName: "Trung tâm",
  centerHubSortName: "TT",
  poHubLongName: "Chi nhánh",
  poHubSortName: "CN",
  stationHubLongName: "Bưu cục",
  stationHubSortName: "BC",

  pack: "Túi",
  isInTong: true,

  typeRequestCode: TypeCodeHelper.Request.NORMAL,
  defaultSize: 6,
  heightBarcode: 30,
  heightQRCode: 100,

  urlLogo: "/assets/images/logo/thanhbuoi.png",
  // urlLogo:"/assets/images/DlexPNG01 1.png",
  urlLogoMini: "/assets/images/logo/thanhbuoi_mini.png",

  // // // // // PROD
  // apiGeneralUrl: "https://coreapi.thanhbuoi.vn/api",
  // apiCRMUrl: "https://crmapi.thanhbuoi.vn/api",
  // apiPostUrl: "https://postapi.thanhbuoi.vn/api",
  // apiPostImage:"https://postapi.thanhbuoi.vn/",
  // urlTracking: "https://tracuu.thanhbuoi.vn/",
  // urlShort: "http://qr.ssw.vn",

  // /* ------- STG ------- */
  apiGeneralUrl: "https://tbe-coreapi.ssw.vn/api",
  apiCRMUrl: "https://tbe-crmapi.ssw.vn/api",
  apiPostUrl: "https://tbe-postapi.ssw.vn/api",
  apiPostImage: "https://post-api-tbe.ssw.vn/",
  urlTracking: "https://tbe-tracking.ssw.vn/",
  urlShort: "http://qr.ssw.vn",
  // apiPostUrl: "http://localhost:55410/api",
  tokenFirebase: "AIzaSyCVfrBxAaDm3MWP69i4tfAjbvWBRlSh0gY",
  apiVietstarExpress: "",
  paramsApiVietstarExpress: {
    user: "50611",
    pass: "qqqq",
    apikey: "eSg1JdaPo1k:APA91bHGaq6ilA_1N7cVh2nxUpSunxy5s0Z5IMWY70uTs5BPNrwvvhzpA2pU24cncdgBh5LHV_w6O5_ZPUUXOxwMP-ImM2Rem6ATmWMP5t3S9WotemyLKHVMq572ywK2F3nlNQwbFS89",
    data: {
      ChiNhanh: null
    }
  },
};
export const environment = envir;